// extracted by mini-css-extract-plugin
export var social = "_9P_qk";
export var social_content = "_9P_dQk";
export var social_link = "_9P_dPk";